import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faTelegram } from '@fortawesome/free-brands-svg-icons';

const shine = keyframes`
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

const FooterContainer = styled.footer`
  background: rgba(0, 0, 0, 0.95);
  padding: clamp(2rem, 6vw, 4rem) 0;
  position: relative;
  overflow: hidden;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, 
      transparent 0%,
      #ff0000 50%,
      transparent 100%
    );
    background-size: 200% auto;
    animation: ${shine} 3s linear infinite;
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: clamp(2rem, 4vw, 3rem);
  padding: 0 clamp(1rem, 3vw, 2rem);
  width: 100%;
`;

const FooterSection = styled.div`
  h3 {
    color: #ffffff;
    font-size: clamp(1.2rem, 4vw, 1.5rem);
    margin-bottom: clamp(1rem, 3vw, 1.5rem);
    font-family: 'Oswald', sans-serif;
    position: relative;
    display: inline-block;
    transition: transform 0.3s ease;
    
    &:hover {
      transform: translateX(5px);
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 40px;
      height: 3px;
      background: #ff0000;
      transition: width 0.3s ease;
    }
    
    &:hover::after {
      width: 100%;
    }
  }

  p {
    transition: all 0.3s ease;
    
    &:hover {
      color: #fff;
      transform: translateX(5px);
    }
  }

  p {
    color: #888;
    line-height: 1.6;
    margin-bottom: 1rem;
  }
`;

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: clamp(1rem, 3vw, 1.5rem);
  margin-top: clamp(0.8rem, 2vw, 1rem);
  flex-wrap: wrap;

  a {
    color: #fff;
    font-size: 1.5rem;
    transition: all 0.3s ease;
    opacity: 0.8;
    position: relative;

    &:hover {
      color: #ff0000;
      opacity: 1;
      animation: ${bounce} 0.6s ease infinite;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 100%;
      height: 2px;
      background: #ff0000;
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }

    &:hover::after {
      transform: scaleX(1);
    }
  }
`;

const slideIn = keyframes`
  from { transform: translateX(-10px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

const TokenInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.5rem, 2vw, 1rem);
  width: 100%;

  > div {
    animation: ${slideIn} 0.5s ease forwards;
    opacity: 0;

    &:nth-child(1) { animation-delay: 0.1s; }
    &:nth-child(2) { animation-delay: 0.2s; }
    &:nth-child(3) { animation-delay: 0.3s; }
  }

  .label {
    color: #666;
    font-size: 0.9rem;
    text-transform: uppercase;
    transition: color 0.3s ease;
  }

  .value {
    color: #fff;
    font-family: monospace;
    background: rgba(255, 255, 255, 0.05);
    padding: clamp(0.4rem, 2vw, 0.5rem);
    border-radius: 4px;
    font-size: clamp(0.8rem, 2.5vw, 0.9rem);
    word-break: break-all;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 0, 0, 0.1);
      transform: translateX(5px);
    }
  }
`;

const QuickLink = styled.a`
  color: #888;
  text-decoration: none;
  display: block;
  margin-bottom: 1rem;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 1.2rem;

  &::before {
    content: '→';
    position: absolute;
    left: 0;
    opacity: 0;
    transform: translateX(-10px);
    transition: all 0.3s ease;
  }

  &:hover {
    color: #fff;
    transform: translateX(10px);
    
    &::before {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>About $TETE</h3>
          <p>Trump Pepe ($TETE) combines the power of memes with the innovation of Solana. Join us in making Solana great again!</p>
          <SocialLinks>
            <a href="https://twitter.com/TeteSol" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href="https://t.me/TETESOLCTO" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTelegram} />
            </a>
          </SocialLinks>
        </FooterSection>
        
        <FooterSection>
          <h3>Token Info</h3>
          <TokenInfo>
            <div>
              <div className="label">Token Name</div>
              <div className="value">Trump Pepe</div>
            </div>
            <div>
              <div className="label">Symbol</div>
              <div className="value">$TETE</div>
            </div>
            <div>
              <div className="label">Network</div>
              <div className="value">Solana</div>
            </div>
            <div>
              <div className="label">Contract</div>
              <div className="value" style={{ fontSize: '0.75rem' }}>6iYhXiSSsYxgbgGSRatENrPm12AA68ruZvD39UTRFjvv</div>
            </div>
          </TokenInfo>
        </FooterSection>

        <FooterSection>
          <h3>Quick Links</h3>
          <QuickLink 
            href="https://raydium.io/swap/?inputCurrency=sol&outputCurrency=6iYhXiSSsYxgbgGSRatENrPm12AA68ruZvD39UTRFjvv&fixed=in" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Buy $TETE
          </QuickLink>
          <QuickLink 
            href="https://dexscreener.com/solana/878fuwoov1rw4mcewwphlgafdntg9jxzwvuadkrzhzky" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Live Chart
          </QuickLink>
          <QuickLink 
            href="https://t.me/TETESOLCTO" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Telegram Channel
          </QuickLink>
          <QuickLink 
            href="https://t.me/TheTrumpPepe_Bot" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            TETE AI Bot
          </QuickLink>
        </FooterSection>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
